import { BrandLogoEntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomBrandLogoEvents } from "../events";
import { RoomBrandLogoActions } from "../actions";

export const ROOM_BRAND_LOGO_FEATURE_KEY = "roomBrandLogo";

export interface RoomBrandLogoState extends EntityState<Record<string, never>> {
  isLoading: boolean;
  brandLogo: null | BrandLogoEntityRaw;
}

export const roomBrandLogoAdapter: EntityAdapter<Record<string, never>> =
  createEntityAdapter();

const initialState: RoomBrandLogoState = roomBrandLogoAdapter.getInitialState({
  isLoading: false,
  brandLogo: null
});

const reducer = createReducer(
  initialState,
  on(RoomBrandLogoActions.roomBrandLogoCreate, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandLogoActions.roomBrandLogoCreateSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoCreateFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoDelete, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandLogoActions.roomBrandLogoDeleteSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoDeleteFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoUnUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandLogoActions.roomBrandLogoUnUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoUnUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandLogoActions.roomBrandLogoUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoActions.roomBrandLogoUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandLogoEvents.roomBrandLogoDeleteEvent, (state) => ({
    ...state,
    brandLogo: null
  })),
  on(
    RoomBrandLogoEvents.roomBrandLogoSetEvent,
    (state, { roomBrandLogoSetEventVO }) => ({
      ...state,
      brandLogo: roomBrandLogoSetEventVO.value.brandLogo.toJSON()
    })
  )
);

export function roomBrandLogoReducer(
  state: RoomBrandLogoState | undefined,
  action: Action
) {
  return reducer(state, action);
}
